<template>
  <div id="page-user-list">
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <div class="flex-grow">
          <span  class="title-page ml-6">{{jobName}}</span>
        </div>
      </div>
    </div>
    <div class="vx-card p-6 mt-4"  >
      <div class="vx-col mb-5">
        <vs-button
          @click="createTopicTrial"
          color="primary"
          type="border"
          icon-pack="feather"
          icon="icon-plus">
          {{$t('trial.addTopic')}}
        </vs-button>

      </div>
      <div class="vx-col" >
        <vs-collapse accordion :type="type">
        <vs-collapse-item icon-arrow="arrow_drop_down" style="background-color: #fafafa" v-for="(itemTopic, index) in topics"
                          :key="index">
          <div slot="header">
            <div class="vx-row ml-0">
              <span class="ml-2 mt-1 font-bold title-header">{{ itemTopic.topicName }}</span>
              <span class=" mt-1 ml-6 mr-6 title-length">{{itemTopic.keywords.length}} {{ $t('projectAndTopic.keyword') }}</span>
              <div class="dropdown" style="position: absolute; right:20px">
                <vs-dropdown class="cursor-pointer" style="margin-top: 2px;">
                  <feather-icon
                    icon="MoreHorizontalIcon"
                    class=""
                    style="color: rgb(110 107 123);width: 1.7rem"
                  >
                  </feather-icon>
                  <vs-dropdown-menu>
                    <ul style="min-width: 228pt">
                      <li class="border-bottom flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                          @click="createTopicTrial(itemTopic)">
                        <feather-icon
                          icon="Edit3Icon"
                          style="vertical-align:middle;width:1rem"
                        >
                        </feather-icon>
                        <span class="font-action ml-2 mt-1"
                              @click="createTopicTrial(itemTopic)">{{ $t('projectAndTopic.editTopic') }}</span>
                      </li>
                      <li class="border-bottom flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                          @click="confirmRemoveTopicGroup(itemTopic)">
                        <feather-icon
                          icon="Trash2Icon"
                          style="vertical-align:middle;width:1rem"
                          @click="confirmRemoveTopicGroup(itemTopic)"
                        >
                        </feather-icon>
                        <span class="font-action ml-2 mt-1">{{ $t('projectAndTopic.deleteTopic') }}</span>
                      </li>
                    </ul>
                  </vs-dropdown-menu>

                </vs-dropdown>
              </div>
            </div>
          </div>
          <div v-for="(key, indexKey) in itemTopic.keywords" :key="indexKey">
              <span class="title-keyword ml-2">{{key.keyword}}</span>
          </div>
        </vs-collapse-item>

        </vs-collapse>
      </div>
    </div>
  </div>
</template>

<script>


import moment from "moment";

export default {
  components: {
  },
  data() {
    return {
      // Cell Renderer Components
      type : 'border',
      topics : [],
      jobName : null,
      jobList: [
        {label:'Bán lẻ & thương mại', value: 0},
        {label: 'Bảo hiểm', value: 1},
        {label: 'Bất động sản', value: 3},
        {label: 'CNTT & Viễn thông', value: 4},
        {label: 'Dịch vụ công & nhà nước', value: 5},
        {label: 'Dịch vụ vận tải', value: 6},
        {label: 'Dược và Y tế', value: 7},
        {label: 'Fintech', value: 8},
        {label: 'Giải trí', value: 9},
        {label: 'Giáo dục', value: 10},
        {label: 'Giao nhận vận tải', value: 11},
        {label: 'Khách sạn và nhà nghỉ', value: 12},
        {label: 'Làm đẹp, Mỹ phẩm & Sức khoẻ', value: 13},
        {label: 'Luật/Pháp lý', value: 14},
        {label: 'Năng lượng', value: 15},
        {label: 'Nông nghiệp', value: 16},
        {label: 'Quảng cáo/Truyền thông', value: 17},
        {label: 'Tài chính/Ngân hàng', value: 18},
        {label: 'Thực phẩm & Đồ uống', value: 19},
        {label: 'Thương mại điện tử', value: 20},
        {label: 'Tiêu dùng nhanh', value: 21},
        {label: 'Xây dựng', value: 22},
        {label: 'Khác', value: -1},
      ],
    }
  },
  created() {
    this.initScreen();
  },
  watch: {
    '$store.state.windowWidth'(val) {
      if (val <= 1024) {
        this.maxPageNumbers = 5;
      } else {
        this.maxPageNumbers = 7;
      }

      if (val > 1024) {
        this.gridApi.sizeColumnsToFit();
      }
    },
    '$store.state.reduceButton'() {
      setTimeout(() => {
        this.gridApi.sizeColumnsToFit();
      }, 650);
    },
    '$store.state.isUpdateUser'(val) {
      if (val) {
        this.initScreen();
        this.$store.commit('UPDATE_USER_SUCCESS', false);
      }
    },
  },
  computed: {
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  methods: {
    filterJobName : function () {
      let id = this.$route.query.id
      let tmp = this.jobList.find(el => el.value == id)
      this.jobName = tmp.label
    },
    createTopicTrial(itemTopic) {
      let id = this.$route.query.id
      let topicId = itemTopic ? itemTopic.id : null;
      let url = `/admin/trial-create-topic?id=${id}`;
      if (topicId) url += "&topicId=" + topicId
      this.$router.push(url).catch(() => {
      });
    },
    createKeywordTrial(item) {
      this.$router.push(`/admin/trial-create-keyword?id=${item.id}&idUpdate=true`).catch(() => {
      });
    },
    getTopicByOrganizationBranding: function () {
      let type = this.$route.query.id;
      const payload = {};
      this.$business
        .post(`topic/find-by-conditions/${type}`, payload)
        .then(res => {
            this.topics = res.data;
            return {

            }
        })
    },

    initScreen() {
        this.getTopicByOrganizationBranding();
        this.filterJobName()
    },
  },
}
</script>

<style scoped>
.title-page{
  font-size: 2.2rem;
  font-weight: bold;
}

</style>
<style lang="css">
.vs-collapse-item--icon-header {
  left: 0 !important;
  margin-left: 10px;
}
.title-header {
  font-size: 14px;
  color:  rgb(94 88 115)
}
.title-keyword {
  font-size: 14px;
  color: #2F80ED
}
.title-length {
  font-size: 13px;
  color:  rgb(185 185 195)
}
</style>
